export default {"src":"/_next/static/media/waking-up.mono.5db746db.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};